"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
export default function WhatIsTheAdministrativeLeak() {
  const {
    ref: textRef1,
    isVisible: textVisible1
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: textRef2,
    isVisible: textVisible2
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: textRef3,
    isVisible: textVisible3
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section className="relative min-h-screen bg-[#0A0A0A] py-20 px-6 lg:px-12">
      <div className="container mx-auto max-w-7xl">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div className="space-y-12">
            <div ref={textRef1} className="transition-all duration-200 ease-[cubic-bezier(0.4,0,0.2,1)]" style={{
            opacity: textVisible1 ? 1 : 0,
            transform: textVisible1 ? "translateY(0)" : "translateY(20px)"
          }}>
              <h2 className="font-display text-4xl font-bold mb-4 !text-[hsl(210,11%,71%)] lg:text-5xl">
                What Is the <span className="!text-[hsl(213,94%,68%)]">Administrative Leak</span>?
              </h2>
              <p className="text-foreground-dark/80 text-lg leading-relaxed">
                The Administrative Leak is the invisible drain on your time and energy—endless emails, 
                manual scheduling, data entry, and repetitive tasks that pull you away from your creative mission.
              </p>
            </div>

            <Separator className="bg-primary/40" />

            <div ref={textRef2} className="transition-all duration-200 ease-[cubic-bezier(0.4,0,0.2,1)]" style={{
            opacity: textVisible2 ? 1 : 0,
            transform: textVisible2 ? "translateY(0)" : "translateY(20px)"
          }}>
              <h3 className="font-display text-2xl lg:text-3xl font-semibold text-secondary mb-3">
                Why It Matters
              </h3>
              <p className="text-foreground-dark/80 text-base leading-relaxed">
                For dance studio owners and nonprofit directors, every hour lost to admin chaos is an hour 
                stolen from artistry, community impact, and strategic growth. The leak compounds daily, 
                turning passion into burnout.
              </p>
            </div>

            <Separator className="bg-secondary/40" />

            <div ref={textRef3} className="transition-all duration-200 ease-[cubic-bezier(0.4,0,0.2,1)]" style={{
            opacity: textVisible3 ? 1 : 0,
            transform: textVisible3 ? "translateY(0)" : "translateY(20px)"
          }}>
              <h3 className="font-display text-2xl font-semibold mb-3 !text-[hsl(84,81%,44%)] lg:text-3xl">The Agentic Artist Solution</h3>
              <p className="text-foreground-dark/80 text-base leading-relaxed mb-6">
                Our Strategy Audit pinpoints your exact leaks and designs a custom AI-driven automation 
                architecture to seal them permanently. Reclaim your rhythm. Focus on what matters.
              </p>
              {}
              <Link to="https://forms.fillout.com/t/teUkS15Xkjus" className="inline-flex items-center justify-center rounded-md bg-primary text-foreground-primary px-6 py-3 font-semibold hover:bg-primary-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-primary-active active:translate-y-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
                Request Your Audit
              </Link>
            </div>
          </div>

          {}
          <div ref={imageRef} className="relative transition-all duration-[250ms] ease-out" style={{
          opacity: imageVisible ? 1 : 0,
          transform: imageVisible ? "translateX(0)" : "translateX(60px)"
        }}>
            <div className="relative rounded-lg overflow-hidden border-2 border-primary/60 shadow-strong group" onMouseEnter={e => {
            if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
              e.currentTarget.style.transform = "rotate(0.5deg)";
            }
          }} onMouseLeave={e => {
            e.currentTarget.style.transform = "rotate(0deg)";
          }} style={{
            transition: "transform 200ms cubic-bezier(0.34,1.56,0.64,1)"
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1496898/img/administrative_leak_visualization.png" alt="Administrative Leak Visualization - Data flow diagram with neon highlights" className="w-full h-auto object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/80 via-transparent to-transparent pointer-events-none" />
            </div>

            {}
            <div className="absolute -inset-2 bg-primary/10 blur-2xl rounded-lg -z-10" />
          </div>
        </div>
      </div>
    </section>;
}